import { render, staticRenderFns } from "./ModalConsignmentCreate.vue?vue&type=template&id=e4d719d6&"
import script from "./ModalConsignmentCreate.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports